import {ReactElement} from "react";
import {styles} from "./styles/OptionHorizontalDivider.style";


const OptionHorizontalDivider = (): ReactElement => {
  return (
    <div style={styles.OptionHorizontalDivider}></div>
  )
}

export default OptionHorizontalDivider;